<div class="service-unavailable" *transloco="let t; prefix: 'core.serviceUnavailable'">
  <div class="service-unavailable__lang">
    <app-language-switcher variant="primary" />
  </div>

  <div class="service-unavailable__content">
    <mat-icon class="service-unavailable__icon" aria-hidden="true">cloud_off</mat-icon>
    <h1 class="service-unavailable__title">{{ t('title') }}</h1>
    <p class="service-unavailable__message">{{ t('message') }}</p>
    <button mat-raised-button color="primary" type="button" (click)="reload()">{{ t('retry') }}</button>
  </div>
</div>
